<template>
  <div class="sonpage-container"> 
    <div class="son-main">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane name="wifi">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="wifi.isApply"></i>{{ $t('messageAdd.common.001') }}
          </span>
          <wifi :wifi="wifi.content" ref="wifiRef" @update:wifi="handleWifiUpdate"></wifi>
        </el-tab-pane>
        <el-tab-pane name="mobileNet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="mobileNet.isApply"></i>{{ $t('messageAdd.common.002') }}
          </span>
          <mobileNet :mobileNet="mobileNet.content" @update:mobileNet="handleMobileNetUpdate"></mobileNet>
        </el-tab-pane>
        <el-tab-pane name="launcherSet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="launcher.isApply"></i>{{ $t('messageAdd.common.003') }}
          </span>
          <launcherSet :launchers="launcher.content" @update:launcher="handleLauncherUpdate"></launcherSet>
        </el-tab-pane>
        <el-tab-pane name="displaySet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="displaySet.isApply"></i>{{ $t('messageAdd.common.004') }}
          </span>
          <displaySet :displaySet="displaySet.content" @update:displaySet="handleDisplaySetUpdate"></displaySet>
        </el-tab-pane>
        <el-tab-pane name="sound">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="sound.isApply"></i>{{ $t('messageAdd.common.005') }}
          </span>
          <sound :sound="sound.content" @update:sound="handleSoundUpdate"></sound>
        </el-tab-pane>
        <el-tab-pane name="timeSet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="timeSet.isApply"></i>{{ $t('messageAdd.common.006') }}
          </span>
          <timeSet :timeSet="timeSet.content" @update:timeSet="handleTimeSetUpdate"></timeSet>
        </el-tab-pane>
        <el-tab-pane name="USBSet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="USBSet.isApply"></i>{{ $t('messageAdd.common.007') }}
          </span>
          <USBSet :USBSet="USBSet.content" @update:USBSet="handleUSBSetUpdate"></USBSet>
        </el-tab-pane>
        <el-tab-pane name="GeneralSet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="GeneralSet.isApply"></i>{{ $t('messageAdd.common.008') }}
          </span>
          <GeneralSet :GeneralSet="GeneralSet.content" @update:GeneralSet="handleGeneralSetUpdate"></GeneralSet>
        </el-tab-pane>
        <el-tab-pane name="featuredSet">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="featuredSetNoFilter.isApply"></i>{{ $t('messageAdd.common.009') }}
          </span>
          <featuredSet :featuredSetNoFilter='featuredSetNoFilter.content'
            @update:featuredSetFilter="handleFeaturedSetUpdate"
            @update:featuredSetNoFilter="handleFeaturedSetUpdateNoFliter"></featuredSet>
        </el-tab-pane>
        <el-tab-pane name="scanningTool">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="scanToolDataNoFilter.isApply"></i>{{ $t('messageAdd.common.010') }}
          </span>
          <scanningTool
            :scanToolDataNoFilter="scanToolDataNoFilter.content"
            @update:scanToolDataNoFilter="handleScanToolDataUpdateNoFliter"
            @update:scanToolDataFilter="handleScanToolData"
            :appSettingDataNoFilter="appSettingDataNoFilter.content"
            @update:appSettingDataNoFilter="handleAppSetDataNoFilter"
            @update:appSettingDataFilter="handleAppSettingData"
            :deleteAllAppData="deleteAllAppData"
            @allChildAppDataDeleted="allChildAppDataDeleted"
          ></scanningTool>
        </el-tab-pane>
        <el-tab-pane name="dataWedge">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="dataWedgeIsApply"></i>Data Wedge
          </span>
          <dataWedge ref="dataWedgeRef" :isCustomPage=false @handleDataWedgeIsApply="handleDataWedgeIsApply">
          </dataWedge>
        </el-tab-pane>
        <el-tab-pane name="mobileButler">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="mobileButler.isApply"></i>{{ $t('messageAdd.common.011') }}
          </span>
          <MobileButler ref="mobileButlerRef" :mobileButler="mobileButler.content" @update:mobileButler="handleMobileButlerUpdate"></MobileButler>
        </el-tab-pane>
        <el-tab-pane name="shortCutKey">
          <span slot="label">
            <i class="el-icon-success" style="color: #51d351" v-if="shortCutKey.isApply"></i>{{ $t('messageAdd.common.012') }}
          </span>
          <ShortCutKey :shortCutKey="shortCutKey.content" @update:shortCutKey="handleShortCutKeyUpdate"></ShortCutKey>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页脚 -->
    <div class="footer-btns">
      <footer-btn
        @resetCommonData="resetCommonData"
        @saveAsPlan="saveAsPlan"
        @commonFatherPagePreviewQRCode="commonFatherPagePreviewQRCode"
        @handleDownLoadCommonQRCodeImg="handleDownLoadCommonQRCodeImg"
        @handleDownLoadCommonQrCodeFile="handleDownLoadCommonQrCodeFile"
        @handlePreviewCommonQrCodeFile="handlePreviewCommonQrCodeFile"
      ></footer-btn>
    </div>
    <!-- 保存为方案组件 -->
    <save-plan
      :showPlanDialog.sync="planDialogVisible"
      :savePlanId="savePlanId"
      :saveName="saveName"
      :planType="planType"
      :fatherPlanData="fatherPlanData"
      :fatherPlanNoHandleData="fatherPlanNoHandleData"
      @handleClosePlanDialog="handleClosePlanDialog"
    ></save-plan>
    <!-- 二维码展示子组件 -->
    <qrcode-page :showDialog.sync="isQRCodeVisible" :qrCodeTxt="qrCodeTxt" :qrCodeTitle="qrCodeTitle"></qrcode-page>
  </div>
</template>
<script>
import wifi from '@/views/menuPage/ConfigComponents/wifi.vue';
import mobileNet from '@/views/menuPage/ConfigComponents/mobileNet.vue';
import launcherSet from '@/views/menuPage/ConfigComponents/LauncherSet.vue';
import displaySet from '@/views/menuPage/ConfigComponents/DisplaySettings.vue';
import sound from '@/views/menuPage/ConfigComponents/sound.vue';
import timeSet from '@/views/menuPage/ConfigComponents/timeSetting.vue';
import USBSet from '@/views/menuPage/ConfigComponents/USBSetting.vue';
import GeneralSet from '@/views/menuPage/ConfigComponents/GeneralSettings.vue';
import featuredSet from '@/views/menuPage/ConfigComponents/FeatureSetting.vue';
import scanningTool from '@/views/menuPage/ConfigComponents/ScanTool.vue';
import dataWedge from '@/views/menuPage/ConfigComponents/dataWedge.vue';
import MobileButler from '@/views/menuPage/ConfigComponents/MobileButler.vue';
import ShortCutKey from '@/views/menuPage/ConfigComponents/ShortCutKey.vue';
import footerBtn from "@/components/footerBtns.vue";
import qrcodePage from "@/components/showQRCode.vue";
import savePlan from "@/components/saveAsPlan.vue";
import { downFileData, txtToQRtxt } from '@/utils/qrCodeFunctions.js';
import QRCode from 'qrcode';
import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { cloneDeep, omit, isEmpty } from 'lodash';
import { isEqual } from 'lodash';
import { isPrivate } from '@/config';
import Cookies from "js-cookie";
import { removeEmptyProperty } from '@/utils';
export default {
  data() {
    // 热键设置默认值（UI绑定格式：数组结构）
    const defaultShortCutKey = {
      DeleteConfig: {
        BroadcastInfo: [],
      },
      BroadcastInfo: [],
      KeyMappingInfo: [],
    }
    // 移动管家默认值
    const defaultMobileButler = {
      DeleteConfig: {},
      AppList: [],
      auto_start_app: {},
      Setting: {
        account_info: {},
        password_protection: {},
      },
      wp: {},
    }
    // 特色配置默认值
    const defaultFeatureSetData = {
      softinput: {
        type: "int",
        value: null
      },
      allow_install_apps: {
        type: "int",
        value: null
      },
      scankey_awake_screen: {
        type: "int",
        value: null
      },
      vkey1_disabled: {
        type: "int",
        value: null
      },
      vkey2_disabled: {
        type: "int",
        value: null
      },
      vkey3_disabled: {
        type: "int",
        value: null
      },
      glove_mode: {
        type: "int",
        value: null
      },
      drop_down: {
        type: "int",
        value: null
      },
      scankey_code: {
        type: "int",
        value: null
      },
      scan_float: {
        type: "int",
        value: null
      },
      force_imei: {
        type: "int",
        value: null
      },
      drop_detection_disabled: {
        type: "int",
        value: null
      },
      developer_no_password: {
        type: "int",
        value: null
      },
      keypad_mode_stick_once: {
        type: "int",
        value: null
      },
      P5_disable: {
        type: "int",
        value: null
      },
      P7_disable: {
        type: "int",
        value: null
      },
      recent_transfer_menu: {
        type: "int",
        value: null
      },
      disable_key_home: {
        type: "int",
        value: null
      },
      disable_key_lockscreen: {
        type: "int",
        value: null
      },
      install_no_market_apps: {
        type: "int",
        value: null
      },
      keypadsound: {
        type: "int",
        value: null
      },
      allow_document_install_apps: {
        type: "int",
        value: null
      },
      fixed_charge_mode: {
        type: "int",
        value: null
      },
      scankey_awake_scan: {
        type: "int",
        value: null
      },
      wake_gesture_enable: {
        type: "int",
        value: null
      },
      voice_enable: {
        type: "int",
        value: null
      },
      usb_only_charge: {
        type: "int",
        value: null
      },
      screen_all_rotation: {
        type: "int",
        value: null
      },
      app_compatibility: {
        type: "int",
        value: null
      },
      scan_focus_mode_enhance: {
        type: "int",
        value: null
      },
      custom_button: {
        type: "int",
        value: null
      },
      double_click_awake_screen: {
        type: "int",
        value: null
      }
    };
    // 扫描参数
    const defaultScanToolSetData = {
      security_level: {
        type: "int",
        value: undefined,
      },
      illumination_level: {
        type: "int",
        value: null,
      },
      exp_level: {
        type: "int",
        value: null,
      },
      picklist_mode: {
        type: "int",
        value: null,
      },
      gs1_ai_separator: {
        type: "int",
        value: null,
      },
      transfer_aim_id: {
        type: "int",
        value: null,
      },
      hold_scanning_time_out: {
        type: "int",
        value: undefined,
      },
      scan_time_out: {
        type: "int",
        value: undefined,
      },
      dpm: {
        type: "int",
        value: null,
      },
      illumination_on: {
        type: "int",
        value: null,
      },
      scene_mode: {
        type: "int",
        value: null,
      },
      multi_code_number: {
        type: "int",
        value: undefined,
      },
      multi_code_timeout: {
        type: "int",
        value: undefined,
      },
      // code128
      code128: {
        type: "int",
        value: null,
      },
      code128_len_min: {
        type: "int",
        value: undefined,
      },
      code128_len_max: {
        type: "int",
        value: undefined,
      },
      isbt128: {
        type: "int",
        value: null,
      },
      gs1128: {
        type: "int",
        value: null,
      },
      code128_quiet_zone: {
        type: "int",
        value: null,
      },
      c128_inverse: {
        type: "int",
        value: null,
      },
      c128_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // UPC/EAN
      upca: {
        type: "int",
        value: null,
      },
      upce: {
        type: "int",
        value: null,
      },
      upce1: {
        type: "int",
        value: null,
      },
      ean8: {
        type: "int",
        value: null,
      },
      ean13: {
        type: "int",
        value: null,
      },
      upca_chk: {
        type: "int",
        value: null,
      },
      upce_chk: {
        type: "int",
        value: null,
      },
      ean13_chk_send: {
        type: "int",
        value: null,
      },
      ean8_chk_send: {
        type: "int",
        value: null,
      },
      upca_pream: {
        type: "int",
        value: null,
      },
      upce_pream: {
        type: "int",
        value: null,
      },
      upce_expanded: {
        type: "int",
        value: null,
      },
      upca_2char_addenda: {
        type: "int",
        value: null,
      },
      upca_5char_addenda: {
        type: "int",
        value: null,
      },
      upce_2char_addenda: {
        type: "int",
        value: null,
      },
      upce_5char_addenda: {
        type: "int",
        value: null,
      },
      ean13_2char_addenda: {
        type: "int",
        value: null,
      },
      ean13_5char_addenda: {
        type: "int",
        value: null,
      },
      ean8_2char_addenda: {
        type: "int",
        value: null,
      },
      ean8_5char_addenda: {
        type: "int",
        value: null,
      },
      upc_ean_quiet_zone: {
        type: "int",
        value: null,
      },
      upc_inverse: {
        type: "int",
        value: null,
      },
      ean_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      //code 39
      code39: {
        type: "int",
        value: null,
      },
      code39_full_ascii: {
        type: "int",
        value: null,
      },
      code39_len_min: {
        type: "int",
        value: undefined,
      },
      code39_len_max: {
        type: "int",
        value: undefined,
      },
      code39_chk: {
        type: "int",
        value: null,
      },
      code39_ver: {
        type: "int",
        value: null,
      },
      code39_start_stop: {
        type: "int",
        value: null,
      },
      code39_quiet_zone: {
        type: "int",
        value: null,
      },
      code39_inverse: {
        type: "int",
        value: null,
      },
      c39_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // code 93
      code93: {
        type: "int",
        value: null,
      },
      code93_len_min: {
        type: "int",
        value: undefined,
      },
      code93_len_max: {
        type: "int",
        value: undefined,
      },
      code93_quiet_zone: {
        type: "int",
        value: null,
      },
      code93_inverse: {
        type: "int",
        value: null,
      },
      // code11
      code11: {
        type: "int",
        value: null,
      },
      code11_len_min: {
        type: "int",
        value: undefined,
      },
      code11_len_max: {
        type: "int",
        value: undefined,
      },
      code11_chk_ver: {
        type: "int",
        value: null,
      },
      code11_chk: {
        type: "int",
        value: null,
      },
      // inter2to5
      i25: {
        type: "int",
        value: null,
      },
      i25_len_min: {
        type: "int",
        value: undefined,
      },
      i25_len_max: {
        type: "int",
        value: undefined,
      },
      i25_chk: {
        type: "int",
        value: null,
      },
      i25_quiet_zone: {
        type: "int",
        value: null,
      },
      i25_inverse: {
        type: "int",
        value: null,
      },
      i25_to_ean13: {
        type: "int",
        value: null,
      },
      // codabar
      codabar: {
        type: "int",
        value: null,
      },
      codabar_len_min: {
        type: "int",
        value: undefined,
      },
      codabar_len_max: {
        type: "int",
        value: undefined,
      },
      codabar_stop_start: {
        type: "int",
        value: null,
      },
      codabar_quiet_zone: {
        type: "int",
        value: null,
      },
      codabar_inverse: {
        type: "int",
        value: null,
      },
      // NEC2to5
      nec25: {
        type: "int",
        value: null,
      },
      nec25_len_min: {
        type: "int",
        value: undefined,
      },
      nec25_len_max: {
        type: "int",
        value: undefined,
      },
      // MSI
      msi: {
        type: "int",
        value: null,
      },
      msi_len_min: {
        type: "int",
        value: undefined,
      },
      msi_len_max: {
        type: "int",
        value: undefined,
      },
      // RSS
      rss14: {
        type: "int",
        value: null,
      },
      rss_limit: {
        type: "int",
        value: null,
      },
      rss_expanded: {
        type: "int",
        value: null,
      },
      // QRCode
      qrcode: {
        type: "int",
        value: null,
      },
      qrcode_len_min: {
        type: "int",
        value: undefined,
      },
      qrcode_len_max: {
        type: "int",
        value: undefined,
      },
      qrinverse: {
        type: "int",
        value: null,
      },
      microqr: {
        type: "int",
        value: null,
      },
      qrmirror: {
        type: "int",
        value: null,
      },
      microqrinverse: {
        type: "int",
        value: null,
      },
      qr_quiet_zone: {
        type: "int",
        value: null,
      },
      // data matrix
      dm: {
        type: "int",
        value: null,
      },
      dm_len_min: {
        type: "int",
        value: undefined,
      },
      dm_len_max: {
        type: "int",
        value: undefined,
      },
      // chinapost
      chinapost: {
        type: "int",
        value: null,
      },
      chinapost_len_min: {
        type: "int",
        value: undefined,
      },
      chinapost_len_max: {
        type: "int",
        value: undefined,
      },
      // m2to5
      m25: {
        type: "int",
        value: null,
      },
      m25_len_min: {
        type: "int",
        value: undefined,
      },
      m25_len_max: {
        type: "int",
        value: undefined,
      },
      // composite
      composite_upcean: {
        type: "int",
        value: null,
      },
      // pdf417
      pdf417: {
        type: "int",
        value: null,
      },
      pdf417_len_min: {
        type: "int",
        value: undefined,
      },
      pdf417_len_max: {
        type: "int",
        value: undefined,
      },
      pdf417_inverse: {
        type: "int",
        value: null,
      },
      pdf417_decoding_rate_enhance: {
        type: "int",
        value: null,
      },
      // microPDF417
      micropdf417: {
        type: "int",
        value: null,
      },
      micropdf417_len_min: {
        type: "int",
        value: undefined,
      },
      micropdf417_len_max: {
        type: "int",
        value: undefined,
      },
      // maxicode
      maxicode: {
        type: "int",
        value: null,
      },
      maxicode_len_min: {
        type: "int",
        value: undefined,
      },
      maxicode_len_max: {
        type: "int",
        value: undefined,
      },
      // aztec
      azteccode: {
        type: "int",
        value: null,
      },
      azteccode_len_min: {
        type: "int",
        value: undefined,
      },
      azteccode_len_max: {
        type: "int",
        value: undefined,
      },
      // codeablockF
      codeblockf: {
        type: "int",
        value: null,
      },
      codeblockf_len_min: {
        type: "int",
        value: undefined,
      },
      codeblockf_len_max: {
        type: "int",
        value: undefined,
      },
      // telepen
      telepen: {
        type: "int",
        value: null,
      },
      telepen_len_min: {
        type: "int",
        value: undefined,
      },
      telepen_len_max: {
        type: "int",
        value: undefined,
      },
      // ocr
      ocr: {
        type: "int",
        value: null,
      },
      ocr_template: {
        type: "int",
        value: null,
      },
      qrc_template: {
        type: "string",
        value: null,
      },
      // Hanxin
      hanxin: {
        type: "int",
        value: null,
      },
    };
    // 应用设置
    const defaultAppSetData = {
      play_sound: {
        type: "boolean",
        value: "",
      },
      play_scan_led: {
        type: "boolean",
        value: "",
      },
      vibrate: {
        type: "boolean",
        value: "",
      },
      append: {
        type: "boolean",
        value: "",
      },
      auto_clear: {
        type: "boolean",
        value: "",
      },
      boot_start: {
        type: "boolean",
        value: "",
      },
      show_barcode_type: {
        type: "boolean",
        value: "",
      },
      filter_invisible_chars: {
        type: "boolean",
        value: "",
      },
      convert_invisible_chars: {
        type: "boolean",
        value: "",
      },
      filter_prefix_suffix_blank: {
        type: "boolean",
        value: "",
      },
      ope_scan_statistics: {
        type: "boolean",
        value: "",
      },
      show_barcode_toast: {
        type: "boolean",
        value: "",
      },
      show_multi_code_scan_float: {
        type: "boolean",
        value: "",
      },
      suffix: {
        type: "string",
        value: "",
      },
      prefix: {
        type: "string",
        value: "",
      },
      end_char: {
        type: "string",
        value: "",
      },
      charset: {
        type: "string",
        value: "",
      },
      advanced_trigger_mode: {
        type: "int",
        value: "",
      },
      send_mode: {
        type: "string",
        value: "",
      },
      barcode_broadcast_name: {
        type: "string",
        value: "",
      },
      barcode_broadcast_key: {
        type: "string",
        value: "",
      },
      start_scan_broadcast_name: {
        type: "string",
        value: "",
      },
      start_stop_broadcast_name: {
        type: "string",
        value: "",
      },
      end_event: {
        type: "boolean",
        value: "",
      },
      block_scan_key_list: {
        type: "string",
        value: "",
      },
      password_md5: {
        type: "string",
        value: "",
      },
      end_char_on_emu: {
        type: "boolean",
        value: ""
      },
      auto_commit_on_emu: {
        type: "boolean",
        value: ""
      },
      // 多条码
      multi_code_splicing: {
        multi_code_normal_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_normal_separator: {
          type: "string",
          value: "",
        },
        multi_code_gs1128_splicing: {
          type: "boolean",
          value: "",
        },
        multi_code_gs1128_separator: {
          type: "string",
          value: "",
        },
      },
      // 条码截断
      split_barcode: {
        split_barcode_mode: {
          type: "int",
          value: "",
        },
        start_index: {
          type: "int",
          value: "",
        },
        end_index: {
          type: "int",
          value: "",
        },
        start_char: {
          type: "string",
          value: "",
        },
        end_char: {
          type: "string",
          value: "",
        },
      },
      // 循环扫描
      scan_continue_internal_params: {
        scan_continue_internal_mode: {
          type: "int",
          value: "",
        },
        scan_continue_normal_internal: {
          type: "int",
          value: "",
        },
        scan_continue_no_data_internal: {
          type: "int",
          value: "",
        },
        scan_continue_with_data_internal: {
          type: "int",
          value: "",
        },
      },
      // 字符替换
      replace_string: []
    }
    // dataWedge默认值
    const defaultDataWedge =[
      { title: "Default", description: "默认通用参数配置文件" },
      { title: "Scan Demo", description: "Scan Demo参数设置", relatedApps: { "com.seuic.dwdemo": ["com.seuic.dwdemo*"] } }
    ];
    const defaultWifi = { id: 1, w: [], bl: [], sl: [] };
    const defaultMobileNet = { id: 2 };
    const defaultLauncher = { id: 3, l: '' };
    const defaultDisplay = { id: 4, b: undefined, wp: {} };
    const defaultSound = { id: 5, m: undefined, r: undefined, a: undefined };
    const defaultTimeSet = { id: 6 };
    const defaultUSBSet = { id: 7 };
    const defaultGeneralSet = { id: 8 };
    const wifiData = localStorage.getItem('wifi') ? JSON.parse(localStorage.getItem('wifi')) : defaultWifi;
    const mobileNetData = localStorage.getItem('mobileNet') ? JSON.parse(localStorage.getItem('mobileNet')) : defaultMobileNet;
    const launcherData = localStorage.getItem('launcher') ? JSON.parse(localStorage.getItem('launcher')) : defaultLauncher;
    const displaySetData = localStorage.getItem('displaySet') ? JSON.parse(localStorage.getItem('displaySet')) : defaultDisplay;
    const soundData = localStorage.getItem('sound') ? JSON.parse(localStorage.getItem('sound')) : defaultSound;
    const timeSetData = localStorage.getItem('timeSet') ? JSON.parse(localStorage.getItem('timeSet')) : defaultTimeSet;
    const USBSetData = localStorage.getItem('USBSet') ? JSON.parse(localStorage.getItem('USBSet')) : defaultUSBSet;
    const GeneralSetData = localStorage.getItem('GeneralSet') ? JSON.parse(localStorage.getItem('GeneralSet')) : defaultGeneralSet;
    const featuredSetData = localStorage.getItem('featuredSetNoFilter') ? JSON.parse(localStorage.getItem('featuredSetNoFilter')) : defaultFeatureSetData;
    const scanToolData = localStorage.getItem('scanToolDataNoFilter') ? JSON.parse(localStorage.getItem('scanToolDataNoFilter')) : cloneDeep(defaultScanToolSetData);
    const appSetData = localStorage.getItem('appSetDataNoFilter') ? JSON.parse(localStorage.getItem('appSetDataNoFilter')) : cloneDeep(defaultAppSetData);
    const mobileButlerData = localStorage.getItem('mobileButler') ? JSON.parse(localStorage.getItem('mobileButler')) : cloneDeep(defaultMobileButler);
    const shortCutKeyData = localStorage.getItem('shortCutKey') ? JSON.parse(localStorage.getItem('shortCutKey')) : cloneDeep(defaultShortCutKey);
    return {
      defaultShortCutKey,
      defaultMobileButler,
      defaultDataWedge,
      defaultFeatureSetData,
      defaultScanToolSetData,
      defaultAppSetData,
      defaultWifi,
      defaultMobileNet,
      defaultLauncher,
      defaultDisplay,
      defaultSound,
      defaultTimeSet,
      defaultUSBSet,
      defaultGeneralSet,
      wifiData,
      mobileNetData,
      launcherData,
      displaySetData,
      soundData,
      timeSetData,
      USBSetData,
      GeneralSetData,
      featuredSetData,
      scanToolData,
      appSetData,
      mobileButlerData,
      shortCutKeyData,
      activeName: 'wifi',
      qrCodeTitle: "",
      isPrivate,
      deleteAllAppData: false,
      // wifi数据
      wifi: {
        content: { ...cloneDeep(wifiData) },
        isApply: true
      },
      // 移动网络
      mobileNet: {
        content: { ...cloneDeep(mobileNetData) },
        isApply: true
      },
      // 启动器数据
      launcher: {
        content: { ...cloneDeep(launcherData) },
        isApply: true
      },
      // 显示数据
      displaySet: {
        content: { ...cloneDeep(displaySetData) },
        isApply: true
      },
      // 声音数据
      sound: {
        content: { ...cloneDeep(soundData) },
        isApply: true
      },
      // 时间数据
      timeSet: {
        content: { ...cloneDeep(timeSetData) },
        isApply: true
      },
      // USB数据
      USBSet: {
        content: { ...cloneDeep(USBSetData) },
        isApply: true
      },
      // 通用设置
      GeneralSet: {
        content: { ...cloneDeep(GeneralSetData) },
        isApply: true
      },
      // 功能设置
      featuredSetNoFilter: {
        content: { ...cloneDeep(featuredSetData) },
        isApply: true
      },
      // 扫描工具
      scanToolDataNoFilter: {
        content: { ...cloneDeep(scanToolData) },
        isApply: true
      },
      // 条码工具
      appSettingDataNoFilter: {
        content: { ...cloneDeep(appSetData) },
      },
      // 移动管家
      mobileButler: {
        content: {...cloneDeep(mobileButlerData)},
        isApply: true
      },
      // 热键设置
      shortCutKey: {
        content: {...cloneDeep(shortCutKeyData)},
        isApply: true
      },
      isQRCodeVisible: false,
      qrCodeTxt: "",
      // 保存方案
      planDialogVisible: false, // 保存方案对话框显示控制
      planType: 1, // 方案类型，默认为1（展示配置常用参数） 1:展示配置常用参数 4:展示停用系统功能项 5:展示自定义配置模式
      fatherPlanData: {}, // 已处理的数据（供第三方外部使用）
      fatherPlanNoHandleData: {}, // 未处理的数据（供组件内部使用）
      // scanToolIsApply: false,
      dataWedgeIsApply: false, // dataWedge是否有修改
      // 路由传来的保存方案数据
      savePlanId: '', // 方案id
      saveName: '' // 方案名称
    };
  },
  components: {
    wifi,
    mobileNet,
    launcherSet,
    displaySet,
    sound,
    timeSet,
    USBSet,
    GeneralSet,
    featuredSet,
    scanningTool,
    dataWedge,
    MobileButler,
    ShortCutKey,
    footerBtn,
    qrcodePage,
    savePlan
  },
  computed: {
    isLogin() {
      return Cookies.get('JSESSIONID_StageNow')
    }
  },
  watch: {
    'wifi.content': {
      handler(newVal) {
        localStorage.setItem('wifi', JSON.stringify(newVal));
      },
      deep: true
    },
    'mobileNet.content': {
      handler(newVal) {
        localStorage.setItem('mobileNet', JSON.stringify(newVal));
      },
      deep: true
    },
    'launcher.content': {
      handler(newVal) {
        localStorage.setItem('launcher', JSON.stringify(newVal));
      },
      deep: true
    },
    'displaySet.content': {
      handler(newVal) {
        localStorage.setItem('displaySet', JSON.stringify(newVal));
      },
      deep: true
    },
    'sound.content': {
      handler(newVal) {
        localStorage.setItem('sound', JSON.stringify(newVal));
      },
      deep: true
    },
    'timeSet.content': {
      handler(newVal) {
        localStorage.setItem('timeSet', JSON.stringify(newVal));
      },
      deep: true
    },
    'USBSet.content': {
      handler(newVal) {
        localStorage.setItem('USBSet', JSON.stringify(newVal));
      },
      deep: true
    },
    'GeneralSet.content': {
      handler(newVal) {
        localStorage.setItem('GeneralSet', JSON.stringify(newVal));
      },
      deep: true
    },
    'featuredSetNoFilter.content': {
      handler(newVal) {
        localStorage.setItem('featuredSetNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    'scanToolDataNoFilter.content': {
      handler(newVal) {
        localStorage.setItem('scanToolDataNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    'appSettingDataNoFilter.content': {
      handler(newVal) {
        localStorage.setItem('appSetDataNoFilter', JSON.stringify(newVal));
      },
      deep: true
    },
    'mobileButler.content': {
      handler(newVal) {
        localStorage.setItem('mobileButler', JSON.stringify(newVal));
      },
      deep: true
    },
    'shortCutKey.content': {
      handler(newVal) {
        localStorage.setItem('shortCutKey', JSON.stringify(newVal));
      },
      deep: true
    },
  },
  methods: {
    // 关闭保存方案对话框
    handleClosePlanDialog(val) {
      this.planDialogVisible = val;
    },
    // wifi数据
    handleWifiUpdate(data) {
      this.wifi.content = data;
      this.wifi.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultWifi))
    },
    // 处理mobileNet数据
    handleMobileNetUpdate(data) {
      this.mobileNet.content = data;
      this.mobileNet.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultMobileNet))
    },
    // 处理launcher数据
    handleLauncherUpdate(data) {
      this.launcher.content = data;
      this.launcher.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultLauncher))
    },
    // 处理displaySet数据
    handleDisplaySetUpdate(data) {
      this.displaySet.content = data;
      this.displaySet.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultDisplay))
    },
    // 处理sound数据
    handleSoundUpdate(data) {      
      this.sound.content = data;
      this.sound.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultSound))
    },
    // 处理timeSet数据
    handleTimeSetUpdate(data) {
      this.timeSet.content = data;
      this.timeSet.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultTimeSet))
    },
    // 处理USBSet数据
    handleUSBSetUpdate(data) {
      this.USBSet.content = data;
      this.USBSet.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultUSBSet))
    },
    // 处理GeneralSet数据
    handleGeneralSetUpdate(data) {
      this.GeneralSet.content = data;
      this.GeneralSet.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultGeneralSet))
    },
    // 处理featuredSet数据已过滤
    handleFeaturedSetUpdate(data) {
      localStorage.setItem('featuredSetFilter', JSON.stringify(data))
    },
    // 处理featuredSet数据未过滤
    handleFeaturedSetUpdateNoFliter(data) {
      this.featuredSetNoFilter.content = data;
      this.featuredSetNoFilter.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultFeatureSetData))
    },
    // 处理scanToolData数据未过滤
    handleScanToolDataUpdateNoFliter(data) {
      this.scanToolDataNoFilter.content = data;
      this.scanToolDataNoFilter.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultScanToolSetData)) || !(JSON.stringify(this.appSettingDataNoFilter.content) === JSON.stringify(this.defaultAppSetData));
    },
    // 处理scanTool数据已过滤
    handleScanToolData(data) {
      localStorage.setItem('scanToolDataFilter', JSON.stringify(data))
    },
    // 处理应用设置未过滤数据
    handleAppSetDataNoFilter(data) {
      this.appSettingDataNoFilter.content = data;
      this.scanToolDataNoFilter.isApply = !(JSON.stringify(this.scanToolDataNoFilter.content) === JSON.stringify(this.defaultScanToolSetData)) || !(JSON.stringify(data) === JSON.stringify(this.defaultAppSetData));
    },
    // 处理应用设置已过滤数据
    handleAppSettingData(data) {
      localStorage.setItem('appSetDataFilter', JSON.stringify(data));
    },
    // 处理dataWdege是否展示图标
    handleDataWedgeIsApply(data) {
      this.dataWedgeIsApply = data;
    },
    // 处理MobileButler数据
    handleMobileButlerUpdate(data) {
      this.mobileButler.content = data;
      this.mobileButler.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultMobileButler))
    },
    // 处理ShortCutKey数据
    handleShortCutKeyUpdate(data) {
      this.shortCutKey.content = data;
      this.shortCutKey.isApply = !(JSON.stringify(data) === JSON.stringify(this.defaultShortCutKey))
    },
    // 兼容旧版 shortCutKey 对象结构数据
    // migrateShortCutKeyIfNeeded() {
    //   const data = this.shortCutKeyData;
    //   let migrated = false;
    //   if (data.DeleteConfig && data.DeleteConfig.BroadcastInfo && !Array.isArray(data.DeleteConfig.BroadcastInfo)) {
    //     data.DeleteConfig.BroadcastInfo = Object.keys(data.DeleteConfig.BroadcastInfo).map(name => ({ name }));
    //     migrated = true;
    //   }
    //   if (data.BroadcastInfo && !Array.isArray(data.BroadcastInfo)) {
    //     data.BroadcastInfo = Object.entries(data.BroadcastInfo).map(([name, value]) => ({ name, ...value }));
    //     migrated = true;
    //   }
    //   if (data.KeyMappingInfo && !Array.isArray(data.KeyMappingInfo)) {
    //     data.KeyMappingInfo = Object.entries(data.KeyMappingInfo).map(([key, value]) => ({ key, ...value }));
    //     migrated = true;
    //   }
    //   if (migrated) {
    //     localStorage.setItem('shortCutKey', JSON.stringify(data));
    //     this.shortCutKey.content = cloneDeep(data);
    //   }
    // },
    // 清除当前页本地存储数据
    resetCommonData() {
      switch (this.activeName) {
        case 'wifi':
          // 清空配置并将值变为初始
          if (localStorage.getItem('wifi') === JSON.stringify(this.defaultWifi)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            this.wifi.isApply = false;
            localStorage.removeItem('wifi');
            this.wifi.content = cloneDeep(this.defaultWifi);
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'mobileNet':
          if (localStorage.getItem('mobileNet') === JSON.stringify(this.defaultMobileNet)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('mobileNet');
            this.mobileNet.isApply = false;
            this.mobileNet.content = cloneDeep(this.defaultMobileNet);
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'launcherSet':
          if (localStorage.getItem('launcher') === JSON.stringify(this.defaultLauncher)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('launcherSet');
            this.launcher.content = cloneDeep(this.defaultLauncher);
            this.launcher.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'displaySet':
          if (localStorage.getItem('displaySet') === JSON.stringify(this.defaultDisplay)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('displaySet');
            this.displaySet.content = cloneDeep(this.defaultDisplay);
            this.displaySet.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'sound':
          if (localStorage.getItem('sound') === JSON.stringify(this.defaultSound)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('sound');
            this.sound.content = cloneDeep(this.defaultSound);
            this.sound.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'timeSet':
          if (localStorage.getItem('timeSet') === JSON.stringify(this.defaultTimeSet)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('timeSet');
            this.timeSet.content = cloneDeep(this.defaultTimeSet);
            this.timeSet.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'USBSet':
          if (localStorage.getItem('USBSet') === JSON.stringify(this.defaultUSBSet)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('USBSet');
            this.USBSet.content = cloneDeep(this.defaultUSBSet);
            this.USBSet.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'GeneralSet':
          if (localStorage.getItem('GeneralSet') === JSON.stringify(this.defaultGeneralSet)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('GeneralSet');
            this.GeneralSet.content = cloneDeep(this.defaultGeneralSet);
            this.GeneralSet.isApply = false;
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'featuredSet':
          if (localStorage.getItem('featuredSetNoFilter') === JSON.stringify(this.defaultFeatureSetData)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'))
          } else {
            localStorage.removeItem('featuredSetFilter');
            localStorage.removeItem('featuredSetNoFilter');
            this.featuredSetNoFilter.content = cloneDeep(this.defaultFeatureSetData);
            this.featuredSetNoFilter.isApply = false;
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'scanningTool':
          localStorage.removeItem('scanToolDataNoFilter');
          localStorage.removeItem('scanToolDataFilter');
          this.scanToolDataNoFilter.content = cloneDeep(this.defaultScanToolSetData);
          localStorage.removeItem('appSetDataNoFilter');
          localStorage.removeItem('appSetDataFilter');
          this.appSettingDataNoFilter.content = cloneDeep(this.defaultAppSetData);
          this.scanToolDataNoFilter.isApply = false;
          this.deleteAllAppData = true;
          this.$message.success(this.$t('messageAdd.note.001'));
          break;
        case 'dataWedge':
          this.$refs.dataWedgeRef.resetData();
          this.dataWedgeIsApply = false;
          this.$message.success(this.$t('messageAdd.note.001'));
          break;
        case 'mobileButler':
          // 清空配置并将值变为初始
          if (localStorage.getItem('mobileButler') === JSON.stringify(this.defaultMobileButler)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'));
          } else {
            this.mobileButler.isApply = false;
            localStorage.removeItem('mobileButler');
            this.mobileButler.content = cloneDeep(this.defaultMobileButler);
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
          break;
        case 'shortCutKey':
          if (localStorage.getItem('shortCutKey') === JSON.stringify(this.defaultShortCutKey)) {
            this.$message.closeAll();
            this.$message.error(this.$t('messageAdd.note.002'));
          } else {
            this.shortCutKey.isApply = false;
            localStorage.removeItem('shortCutKey');
            this.shortCutKey.content = cloneDeep(this.defaultShortCutKey);
            this.$message.closeAll();
            this.$message.success(this.$t('messageAdd.note.001'));
          }
      }
    },
    // 处理扫描工具回调
    allChildAppDataDeleted() {
      this.deleteAllAppData = false;
    },
    // 保存为方案
    saveAsPlan() {
      // 校验 mobileButler 联动必填字段
      if (this.$refs.mobileButlerRef && !this.$refs.mobileButlerRef.validateRequiredFields()) {
        return;
      }
      // 未处理数据(优化点：比较localStorage里数据和默认值，哪些不一样就放在front里，减少不必要的数据传递)
      const front = {
        wifi: localStorage.getItem('wifi') ? JSON.parse(localStorage.getItem('wifi')) : cloneDeep(this.defaultWifi),
        mobileNet: localStorage.getItem('mobileNet') ? JSON.parse(localStorage.getItem('mobileNet')) : cloneDeep(this.defaultMobileNet),
        launcher: localStorage.getItem('launcher') ? JSON.parse(localStorage.getItem('launcher')) : cloneDeep(this.defaultLauncher),
        displaySet: localStorage.getItem('displaySet') ? JSON.parse(localStorage.getItem('displaySet')) : cloneDeep(this.defaultDisplay),
        sound: localStorage.getItem('sound') ? JSON.parse(localStorage.getItem('sound')) : cloneDeep(this.defaultSound),
        timeSet: localStorage.getItem('timeSet') ? JSON.parse(localStorage.getItem('timeSet')) : cloneDeep(this.defaultTimeSet),
        USBSet: localStorage.getItem('USBSet') ? JSON.parse(localStorage.getItem('USBSet')) : cloneDeep(this.defaultUSBSet),
        GeneralSet: localStorage.getItem('GeneralSet') ? JSON.parse(localStorage.getItem('GeneralSet')) : cloneDeep(this.defaultGeneralSet),
        featuredSetNoFilter: localStorage.getItem('featuredSetNoFilter') ? JSON.parse(localStorage.getItem('featuredSetNoFilter')) : cloneDeep(this.defaultFeatureSetData),
        scanToolDataNoFilter: localStorage.getItem('scanToolDataNoFilter') ? JSON.parse(localStorage.getItem('scanToolDataNoFilter')) : cloneDeep(this.defaultScanToolSetData),
        appSetDataNoFilter: localStorage.getItem('appSetDataNoFilter') ? JSON.parse(localStorage.getItem('appSetDataNoFilter')) : cloneDeep(this.defaultAppSetData),
        editableTabs: localStorage.getItem('editableTabs') ? JSON.parse(localStorage.getItem('editableTabs')) : {},
        dataWedgeApp: localStorage.getItem('dataWedgeApp') ? JSON.parse(localStorage.getItem('dataWedgeApp')) : {},
        mobileButler: localStorage.getItem('mobileButler') ? JSON.parse(localStorage.getItem('mobileButler')) : cloneDeep(this.defaultMobileButler),
        shortCutKey: localStorage.getItem('shortCutKey') ? JSON.parse(localStorage.getItem('shortCutKey')) : cloneDeep(this.defaultShortCutKey)
      }
      // 处理过的数据
      const configData = this.handleCommonData();
      // 调用接口传方案至后端
      if (!this.isPrivate && !this.isLogin) {
        // 如果未登录提示先去登录
        this.$message.warning(this.$t('messageAdd.note.003'));
      } else {
        this.planDialogVisible = true;
        this.fatherPlanData = configData;//已处理数据
        this.fatherPlanNoHandleData = front;//未处理数据
      }
    },
    // 导出二维码
    async handleDownLoadCommonQRCodeImg() {
      // 校验 mobileButler 联动必填字段
      if (this.$refs.mobileButlerRef && !this.$refs.mobileButlerRef.validateRequiredFields()) {
        return;
      }
      this.qrCodeTitle = this.$t('messageAdd.mainPage.003');
      const commonData = this.handleCommonData();
      if (commonData && Object.keys(commonData).length > 0) {
        const commonDataStr = JSON.stringify(commonData);
        const qrCodeArr = txtToQRtxt(commonDataStr, '<stn2>');
        if (qrCodeArr.length > 0) {
          const date = new Date();
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const dayStr = year + '' + '0' + month + '' + day;
          const zip = new JSZip();
          const img = zip.folder(`config_${dayStr}`);
          const myNoteName = 'offlineConfigZip';
          for (let i = 0; i < qrCodeArr.length; i++) {
            const url = await QRCode.toDataURL(qrCodeArr[i], {
              width: 200,
              margin: 1,
              errorCorrectionLevel: 'L'
            });
            const image = url.replace(/^data:image\/(png|jpg|jpeg);base64,/, '');
            const imagesName = `${this.qrCodeTitle} ${i + 1}.png`;
            img?.file(imagesName, image, { base64: true });
          }
          const content = await zip.generateAsync({ type: 'blob' });
          FileSaver.saveAs(content, `${myNoteName}.zip`);
        } else {
          console.log('没有配置');
        }
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.note.002'));
      }
    },
    // 下载文件
    handleDownLoadCommonQrCodeFile() {
      // 校验 mobileButler 联动必填字段
      if (this.$refs.mobileButlerRef && !this.$refs.mobileButlerRef.validateRequiredFields()) {
        return;
      }
      const commonData = this.handleCommonData();
      if (commonData && Object.keys(commonData).length > 0) {
        downFileData('Config_stn2.json', JSON.stringify(commonData));
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.note.002'));
      }
    },
    // 处理数据函数
    handleCommonData() {
      // 获取当前的值，先判断是否是默认值，是则跳过，不是则去空处理后放在commonData里
      // 根据pageName返回对应的key
      const getKeyForPageName = (pageName) => {
        switch (pageName) {
          case 'wifi':
            return 'w';
          case 'launcher':
            return 'ls';
          case 'mobileNet':
            return 'm';
          case 'displaySet':
            return 'd';
          case 'sound':
            return 'v';
          case 'timeSet':
            return 't';
          case 'USBSet':
            return 'u';
          case 'GeneralSet':
            return 'c';
          case 'featuredSet':
            return 'fs';
          case 'mobileButler':
            return 'MobileButler';
          case 'shortCutKey':
            return 'ShortCutKey';
          default:
            console.warn(`Unknown pageName: ${pageName}`);
            return null;
        }
      };
      // 默认值对象
      const defaults = {
        wifi: this.defaultWifi,
        launcher: this.defaultLauncher,
        mobileNet: this.defaultMobileNet,
        displaySet: this.defaultDisplay,
        sound: this.defaultSound,
        timeSet: this.defaultTimeSet,
        USBSet: this.defaultUSBSet,
        GeneralSet: this.defaultGeneralSet,
        featuredSetNoFilter: this.defaultFeatureSetData,
        scanToolDataNoFilter: this.defaultScanToolSetData,
        appSetDataNoFilter: this.defaultAppSetData,
        editableTabs: this.defaultDataWedge,//已去空
        mobileButler: this.defaultMobileButler,
        shortCutKey: this.defaultShortCutKey
      };
      // 最终的结果对象
      const commonData = {};
      // 遍历所有你关心的本地存储项
      const keysToCheck = [
        'wifi',
        'launcher',
        'mobileNet',
        'displaySet',
        'sound',
        'timeSet',
        'USBSet',
        'GeneralSet',
        'featuredSetNoFilter',
        'scanToolDataNoFilter',
        'appSetDataNoFilter',
        'editableTabs',
        'mobileButler',
        'shortCutKey'
      ];

      keysToCheck.forEach(key => {
        let storedData = localStorage.getItem(key);
        let parsedData = JSON.parse(storedData);
        if (parsedData != null && !this.isDefaultValue(parsedData, defaults[key])) {
          // 本地值与默认值不相等的处理
          // 'scanToolDataNoFilter','appSetDataNoFilter','editableTabs',shortCutKey单独处理
          if (key === 'editableTabs') {
            commonData.dw = {
              id: 11,
              c: {
                dwSetting: { ...JSON.parse(localStorage.getItem('dataWedgeApp')) },
                configList: [
                  ...this.handleDataWedgeQrCodeData(parsedData)
                ]
              }
            }
          } else if (key === 'scanToolDataNoFilter' || key === 'appSetDataNoFilter') {
            commonData.st = {
              id: 10,
              c: {
                ScanTool: JSON.parse(localStorage.getItem('scanToolDataFilter')),
                AppSetting: JSON.parse(localStorage.getItem('appSetDataFilter'))
              }
            }
          } else if (key === 'featuredSetNoFilter') {
            commonData.fs = {
              id: 9,
              c: { ...JSON.parse(localStorage.getItem('featuredSetFilter')) }
            }
          } else if (key === 'mobileButler') {
            commonData.MobileButler = {
              id: 14,
              c: { MobileButler: removeEmptyProperty(omit(parsedData, ['wp'])) },
            }
            if (!isEmpty(parsedData.wp)) {
              commonData.MobileButler.wp = parsedData.wp;
            }
          } else if (key === 'shortCutKey') {
            commonData.ShortCutKey = {
              id: 15,
              c: { ShortCutKey: { ...this.transformShortCutKeyToExternal(parsedData) } }
            }
          } else {
            const key2 = getKeyForPageName(key); // 获取转换后的键名
            commonData[key2] = this.cleanEmptyStrArrObj(parsedData);
          }
        }
      });
      // 如果commonData里面的dw值为默认值，删除这个dw值
      let defaultDW = {
        id: 11,
        c: {
          dwSetting: {},
          configList: [
            { title: "Default", description: "默认通用参数配置文件" },
            {
              title: "Scan Demo",
              description: "Scan Demo参数设置",
              relatedApps: { "com.seuic.dwdemo": ["com.seuic.dwdemo*"] }
            }
          ]
        }
      }
      if (isEqual(JSON.stringify(defaultDW), JSON.stringify(commonData.dw))) {
        delete commonData.dw;
      }
      return commonData;
    },
    // 判断是否等于默认值
    isDefaultValue(storedData, defaultValue) {
      return JSON.stringify(storedData) === JSON.stringify(defaultValue);
    },
    // 处理dataWedge数据
    handleDataWedgeQrCodeData(qrCodeDataArray) {
      const dArr = []
      qrCodeDataArray.forEach((item) => {
        // 箭头函数避免this指向windows
        if (item && item.content) {
          let c = this.removeEmptyAttrForDataWedge(item.content);
          dArr.push(c)
        } else {
          console.log('没有找到content属性');
        }
      });
      return dArr;
    },
    // 将UI数组结构转换为外部需要的对象结构(针对shortCutKey数据结构特殊处理)
    transformShortCutKeyToExternal(data) {
      const result = {};
      if (data.id !== undefined) {
        result.id = data.id;
      }
      // DeleteConfig
      if (data.DeleteConfig) {
        result.DeleteConfig = {};
        if (data.DeleteConfig.delete_all !== undefined) {
          result.DeleteConfig.delete_all = data.DeleteConfig.delete_all;
        }
        if (data.DeleteConfig.delete_key_mapping_info !== undefined) {
          result.DeleteConfig.delete_key_mapping_info = data.DeleteConfig.delete_key_mapping_info;
        }
        if (data.DeleteConfig.delete_broadcast_info !== undefined) {
          result.DeleteConfig.delete_broadcast_info = data.DeleteConfig.delete_broadcast_info;
        }
        if (data.DeleteConfig.BroadcastInfo && Array.isArray(data.DeleteConfig.BroadcastInfo) && data.DeleteConfig.BroadcastInfo.length > 0) {
          result.DeleteConfig.BroadcastInfo = {};
          data.DeleteConfig.BroadcastInfo.forEach(item => {
            if (item.name) {
              result.DeleteConfig.BroadcastInfo[item.name] = null;
            }
          });
        }
      }
      // BroadcastInfo
      if (data.BroadcastInfo && Array.isArray(data.BroadcastInfo) && data.BroadcastInfo.length > 0) {
        result.BroadcastInfo = {};
        data.BroadcastInfo.forEach(item => {
          if (item.name) {
            const broadcast = {
              action: item.action || '',
              package_name: item.package_name || '',
              class_name: item.class_name || ''
            };
            if (item.parameters && Array.isArray(item.parameters) && item.parameters.length > 0) {
              broadcast.parameters = {};
              item.parameters.forEach(param => {
                if (param.name) {
                  broadcast.parameters[param.name] = {
                    type: param.type,
                    value: param.value
                  };
                }
              });
            }
            result.BroadcastInfo[item.name] = broadcast;
          }
        });
      }
      // KeyMappingInfo
      if (data.KeyMappingInfo && Array.isArray(data.KeyMappingInfo) && data.KeyMappingInfo.length > 0) {
        result.KeyMappingInfo = {};
        data.KeyMappingInfo.forEach(item => {
          if (item.key) {
            const mapping = { type: item.type };
            if (item.type === 'OTHER_KEYCODE') {
              mapping.virtual_key = item.virtual_key || '';
            }
            if (item.type === 'BROADCAST') {
              mapping.broadcast_name = item.broadcast_name || '';
            }
            if (item.type === 'APPLICATION') {
              mapping.package_name = item.package_name || '';
              mapping.class_name = item.class_name || '';
            }
            result.KeyMappingInfo[item.key] = mapping;
          }
        });
      }
      return result;
    },
    // 清空空对象和空数组(递归)
    removeEmptyAttrForDataWedge(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] && typeof obj[key] === 'object') {
          this.removeEmptyAttrForDataWedge(obj[key]);
          if (
            Object.keys(obj[key]).length === 0 ||
            (Array.isArray(obj[key]) && obj[key].length === 0)
          ) {
            delete obj[key];
          }
          // 删除id和indexs值
          else if (key === 'id' || key === 'indexs' || key === 'codeTypeFilterCopy') {
            delete obj[key];
          }
        }
        else if (
          (obj[key] === '' || obj[key] === null || obj[key] === undefined) &&
          !(key === 'replace' && obj['source'])
        ) {
          delete obj[key];
        }
      });
      return obj;
    },
    // 清空为null的value的对象
    cleanNullValues(data) {
      const result = Object.entries(data).filter(([key, value]) => value.value !== null && value.value !== undefined).reduce((acc, [key, value]) => {
        acc[key] = value; // 只包含value不为null的属性
        return acc;
      }, {});
      return result;
    },
    // 处理空数据(数组，对象，字符串)一级
    cleanEmptyStrArrObj(data) {
      const result = {};
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (Array.isArray(value) && value.length === 0) {
            // 如果是空数组，则不添加到结果对象中
          } else if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
            // 如果是空对象，则不添加到结果对象中
          } else if (typeof value === 'string' && value === "") {
            // 如果是空字符串，则不添加到结果对象中
          } else {
            // 否则，添加到结果对象中
            result[key] = value;
          }
        }
      }
      return result;
    },
    // 调用展示二维码信息组件
    commonFatherPagePreviewQRCode() {
      // 校验 mobileButler 联动必填字段
      if (this.$refs.mobileButlerRef && !this.$refs.mobileButlerRef.validateRequiredFields()) {
        return;
      }
      // 从本地取出各个页面的数据并整合
      const commonData = this.handleCommonData();
      if (commonData && Object.keys(commonData).length > 0) {
        // 将对象转为字符串，因为二维码内容不能直接展示对象
        const commonQRtxt = {
          ...commonData
        }
        const commonDataStr = JSON.stringify(commonQRtxt);
        this.qrCodeTxt = commonDataStr;
        this.qrCodeTitle = this.$t('messageAdd.mainPage.003');
        this.isQRCodeVisible = true; // 显示二维码
      } else {
        this.$message.closeAll();
        this.$message.error(this.$t('messageAdd.note.002'));
      }
    },
    // 预览文件
    handlePreviewCommonQrCodeFile() {
      // 校验 mobileButler 联动必填字段
      if (this.$refs.mobileButlerRef && !this.$refs.mobileButlerRef.validateRequiredFields()) {
        return;
      }
      // 从本地取出各个页面的数据并整合
      const commonData = this.handleCommonData();
      console.log('commonData', commonData);
    }
  },
  created() {
    this.wifi.isApply = !(JSON.stringify(this.wifiData) === JSON.stringify(this.defaultWifi));
    this.mobileNet.isApply = !(JSON.stringify(this.mobileNetData) === JSON.stringify(this.defaultMobileNet));
    this.launcher.isApply = !(JSON.stringify(this.launcherData) === JSON.stringify(this.defaultLauncher));
    this.displaySet.isApply = !(JSON.stringify(this.displaySetData) === JSON.stringify(this.defaultDisplay));
    this.sound.isApply = !(JSON.stringify(this.soundData) === JSON.stringify(this.defaultSound));
    this.timeSet.isApply = !(JSON.stringify(this.timeSetData) === JSON.stringify(this.defaultTimeSet));
    this.USBSet.isApply = !(JSON.stringify(this.USBSetData) === JSON.stringify(this.defaultUSBSet));
    this.GeneralSet.isApply = !(JSON.stringify(this.GeneralSetData) === JSON.stringify(this.defaultGeneralSet));
    this.featuredSetNoFilter.isApply = !(JSON.stringify(this.featuredSetData) === JSON.stringify(this.defaultFeatureSetData));
    this.scanToolDataNoFilter.isApply = !(JSON.stringify(this.scanToolData) === JSON.stringify(this.defaultScanToolSetData)) || !(JSON.stringify(this.appSetData) === JSON.stringify(this.defaultAppSetData));
    this.mobileButler.isApply = !(JSON.stringify(this.mobileButlerData) === JSON.stringify(this.defaultMobileButler));
    this.shortCutKey.isApply = !(JSON.stringify(this.shortCutKeyData) === JSON.stringify(this.defaultShortCutKey));
    // 获取路由参数id,name
    this.savePlanId = this.$route.params.id;
    this.saveName = this.$route.params.name;
  },
};
</script>